import React from 'react';

export function ToggleSwitch({ checked, onChange }) {
  return (
    <label className="toggle-switch">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="toggle-switch__slider"></span>
    </label>
  );
}
